import type { AxiosResponse } from 'axios';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { type Datum } from '~/api/hau-itde-reach-portal-api';
import { reachApi } from '~/api/hauItdeReachPortalApi';

export const useApplianceStore = defineStore('appliance', () => {
  //State
  const serialNumber = ref('');
  const pollutants = ref<Datum[] | undefined>(undefined);
  const articleDescription = ref('');
  const sku = ref('');

  //Actions
  const setSerialNumber = (_serialNumber: string) => {
    serialNumber.value = _serialNumber;
  };

  const setPollutants = (_pollutants: Datum[]) => {
    pollutants.value = _pollutants;
  };

  const setArticleDescription = (_articleDescription: string) => {
    articleDescription.value = _articleDescription;
  };

  const setSku = (_sku: string) => {
    sku.value = _sku;
  };

  const loadPollutants = () => {
    return reachApi
      .v1ReachSerialnumberSerialnumberGet(serialNumber.value)
      .then((res) => {
        //set ArticleDescription
        if (!!res.data.data?.externalArticleDescription) {
          setArticleDescription(res.data.data?.externalArticleDescription);
        } else if (!!res.data.data?.articleDescriptionSku) {
          setArticleDescription(res.data.data?.articleDescriptionSku);
        }

        //get&set pollutants
        if (!res.data.data?.sku) {
          throw new Error('sku not found');
        }

        //set Sku
        setSku(res.data.data?.sku);

        //get pollutants
        reachApi
          .v1ReachGet(res.data.data?.sku)
          .then((res: AxiosResponse<Datum[]>) => {
            setPollutants(res.data);
          })
          .catch((err) => {
            throw err;
          });
      })
      .catch((err) => {
        throw err;
      });
  };

  //Getters
  const getReachGuid = computed(() => {
    return pollutants.value?.find((x) => x.reachGuid && x.reachGuid.length > 0)
      ?.reachGuid;
  });

  //Return
  return {
    serialNumber,
    pollutants,
    articleDescription,
    sku,
    setSerialNumber,
    loadPollutants,
    getReachGuid
  };
});
